import Slides from './Slides.js';

import img1 from './images/portfolio/weddings-and-engagements/1/002.jpg';
import img2 from './images/portfolio/weddings-and-engagements/1/002a.jpg';
import img3 from './images/portfolio/weddings-and-engagements/1/003.jpg';
import img4 from './images/portfolio/weddings-and-engagements/1/004.jpg';
import img5 from './images/portfolio/weddings-and-engagements/1/0053_IMG3850.jpg';
import img6 from './images/portfolio/weddings-and-engagements/1/006.jpg';
import img7 from './images/portfolio/weddings-and-engagements/1/007.jpg';
import img8 from './images/portfolio/weddings-and-engagements/1/0078_IMG5001.jpg';
import img9 from './images/portfolio/weddings-and-engagements/1/010.jpg';
import img10 from './images/portfolio/weddings-and-engagements/1/010910_034.jpg';
import img11 from './images/portfolio/weddings-and-engagements/1/010910_138.jpg';
import img12 from './images/portfolio/weddings-and-engagements/1/010910_757.jpg';
import img13 from './images/portfolio/weddings-and-engagements/1/0110.jpg';
import img14 from './images/portfolio/weddings-and-engagements/1/0117_IMG7933.jpg';
import img15 from './images/portfolio/weddings-and-engagements/1/012.jpg';
import img16 from './images/portfolio/weddings-and-engagements/1/014.jpg';
import img17 from './images/portfolio/weddings-and-engagements/1/015.jpg';
import img18 from './images/portfolio/weddings-and-engagements/1/0156IMG_2835.jpg';
import img19 from './images/portfolio/weddings-and-engagements/1/0172_IMG5161.jpg';
import img20 from './images/portfolio/weddings-and-engagements/1/018.jpg';
import img21 from './images/portfolio/weddings-and-engagements/1/0181_IMG5174.jpg';
import img22 from './images/portfolio/weddings-and-engagements/1/018a.jpg';

const images = [ 
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
    img17,
    img18,
    img19,
    img20,
    img21,
    img22,
];

function Architectural() {
    return <Slides images={images}/>;
}

export default Architectural;
